// @archigraph c32W6R8d
// @archigraph 147Ai48u
// User Dashboard for archigraph.io

import { Link } from 'react-router-dom';
import { useAuthStore } from '../store/authStore';
import { Container } from '../components/ui/Container';
import { Card } from '../components/ui/Card';
import { Button } from '../components/ui/Button';

// @archigraph triggers|ui.website.dashboard|interface.auth.session|api (s2n9nLzq)
// @archigraph triggers|ui.website.dashboard|interface.auth.logout|api (Z9MVpcBp)

export function DashboardPage() {
  const { user, logout } = useAuthStore();

  const handleLogout = async () => {
    await logout();
  };

  const initial = user?.name?.charAt(0)?.toUpperCase() || '?';

  return (
    <div className="py-12">
      <Container className="max-w-2xl">
        {/* Header */}
        <p className="text-xs uppercase tracking-widest text-primary mb-4 font-bold">
          // dashboard
        </p>
        <h1 className="text-2xl font-bold text-text mb-8">
          Welcome back, {user?.name || 'there'}
        </h1>

        <div className="flex flex-col gap-px bg-border">
          {/* Profile */}
          <Card padding="lg">
            <div className="flex items-start gap-4">
              <div className="w-10 h-10 border border-primary flex items-center justify-center text-primary font-bold text-sm flex-shrink-0">
                {initial}
              </div>
              <div className="flex-1 min-w-0">
                <h2 className="text-sm font-bold text-text">{user?.name || 'User'}</h2>
                <p className="text-xs text-text-lighter mt-0.5">{user?.email}</p>
              </div>
            </div>
          </Card>

          {/* Downloads */}
          <Card padding="lg">
            <h2 className="text-xs font-bold text-text uppercase tracking-wider mb-4">Downloads</h2>
            <div className="text-center py-4">
              <p className="text-xs text-text-lighter mb-4">
                No downloads yet.
              </p>
              <Link to="/download">
                <Button variant="primary" size="sm">Download Now</Button>
              </Link>
            </div>
          </Card>

          {/* Quick Links */}
          <Card padding="lg">
            <h2 className="text-xs font-bold text-text uppercase tracking-wider mb-4">Quick Links</h2>
            <div className="space-y-2">
              <Link
                to="/download"
                className="flex items-center gap-3 text-xs text-text-light hover:text-primary transition-colors py-1"
              >
                <span className="text-primary">&darr;</span>
                <span>Download latest version</span>
              </Link>
              <a
                href="https://docs.archigraph.io"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-3 text-xs text-text-light hover:text-primary transition-colors py-1"
              >
                <span className="text-primary">&gt;</span>
                <span>Documentation</span>
              </a>
              <button
                onClick={handleLogout}
                className="flex items-center gap-3 text-xs text-text-light hover:text-error transition-colors py-1 w-full text-left"
              >
                <span className="text-error">x</span>
                <span>Log out</span>
              </button>
            </div>
          </Card>

          {/* Coming Soon */}
          <Card padding="lg" className="border-dashed border-border">
            <h2 className="text-xs font-bold text-text-lighter uppercase tracking-wider mb-3">Coming Soon</h2>
            <ul className="space-y-2">
              {['Cloud sync', 'Team collaboration', 'Private sharing'].map((item) => (
                <li key={item} className="flex items-center gap-2 text-xs text-text-lighter">
                  <span className="w-1.5 h-1.5 bg-border" />
                  {item}
                </li>
              ))}
            </ul>
          </Card>
        </div>
      </Container>
    </div>
  );
}
